<template>
  <div>
    <section class="orep-header mont">
      <section class="orep-badge text-uppercase">
        Insurance for Savvy Professionals
      </section>
      <section class="logo-wrapper">
        <img v-if="getApplicantType === 'Mercer'"  src="../../public/assets/images/mercer-logo-white.png"  height="250" width="300" class="logo" alt="Logo">
        <img v-else-if="getApplicantType === 'Realshield'"  src="../../public/assets/images/realshield-logo-blue.png" height="250" width="300" class="logo" alt="Logo">
        <img v-else-if="getApplicantType === 'IBD'"  src="../../public/assets/images/ibdpro-logo.svg" class="logo-ibdpro" alt="Logo">
        <img v-else  src="../../public/assets/images/logo@2.png" class="logo" alt="Logo">
        <span class="logo-text text-uppercase"></span>
      </section>
    </section>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="form-heading title-section auth-title-section form-section flex">
              <h1 class="form-title">Login</h1>
              <img
                src="../../public/assets/images/padlock.png"
                class="title-section-img form-title-img ops-section-img padlock-img"
                alt="background image"
              >
            </article>
            <article class="auth-section">
              <p v-if="getApplicantType ==='OREP'" class="input-info notice-info mb-4">
                Currently Insured with OREP? Login Here.
              </p>
              <div class="row w-100">
                <div class="col-md-6 text-sm-right">
                  <label class="orep-label mb-6">
                    Risk ID / Customer Number:
                  </label>
                </div>
                <div class="col-md-4">
                  <input type="number" class="orep-text-input auth-input w-100"
                         v-model="customerDetail.actContactId"
                         v-validate="'required'"
                         minlength="1"
                         @input="validateBeforeSubmit()">
                </div>
              </div>
              <div class="row w-100">
                <div class="col-md-6 text-sm-right">
                  <label class="orep-label mb-6">
                    Zip Code:
                  </label>
                </div>
                <div class="col-md-4">
                  <input type="number" class="orep-text-input auth-input w-100"
                         v-model="customerDetail.zipCode"
                         v-validate="'required'"
                         oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                         maxlength = "5"
                         minlength="5"
                         @input="validateBeforeSubmit()">
                </div>
              </div>
                <div class="row w-100">
                  <div class="col-md-4 text-sm-right">
                    <label class="orep-label mb-2">
                    </label>
                  </div>
                  <div class="col-md-8">
                    <p>(Use only the first 5 digits of your Zip Code.)</p>
                  </div>
              </div>
              <p v-if="getApplicantType === 'OREP'" class="orep-label input-info notice-info worries" style="font-size: 18px">
                <i class="table-info-fa legalese-fa fas fa-info-circle"></i>
                <span>Forgot your Risk ID or need help logging in?
                  <router-link :to="{name:'forgetPassword'}">
                    <u>Click Here.</u>
                  </router-link>
                </span>
              </p>
              <button :disabled="!state.pageTwoIsValid"
                      :class="{submitDisabled: !state.pageTwoIsValid}"
                      class="login-btn next-btn mont spaced text-uppercase text-center" @click="navigateToNext('about')">Log in <i class="fas fa-arrow-right pull-right"></i></button>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Logging In...</span>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "login",
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    customerDetail() {
      return this.$store.state.customerDetail.customerDetail;
    },
    state() {
      return this.$store.state.customerDetail;
    },
    errorMsg() {
      return this.$store.state.customerDetail.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      if (route === '/portal/login-amba' || route === '/portal/login-amba/' || this.customerDetail.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (route === '/portal/login-realshield' || route === '/portal/login-realshield/' || this.customerDetail.partnerName === 'Realshield'){
        return 'Realshield';
      }
      else if (route === '/portal/login-ibdpro' || route === '/portal/login-ibdpro/' || this.customerDetail.partnerName === 'IBD'){
        return 'IBD';
      }
      else {
        return 'OREP';
      }
    },
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.loading = false;
          this.$notify({
            group: 'error',
            type: 'error',
            text: this.errorMsg,
            duration: 15000,
          });
        }
      },
    },
  },
  methods: {
    prev() {
      this.$router.push({
        name: "login",
      });
    },

    navigateToNext(routeName) {
      if (this.getApplicantType === 'IBD') {
        routeName = 'about-ibdpro';
      }
      else if(this.getApplicantType === 'Mercer'){
        routeName = 'about-amba';
      }
      else if(this.getApplicantType === 'Realshield'){
        routeName = 'about-realshield';
      }
      this.getDetails(routeName);
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageTwoIsValid = true;
          return;
        }
        this.state.pageTwoIsValid = false;
      });
    },

    getDetails(routeName) {
      this.loading = true;
      this.$store.dispatch('customerDetail/getDetails', {routeName});
      this.loading = false;
    },
  },

  mounted() {
    $("html, body").animate(
      {
        scrollTop: $(".page-content").offset().top
      },
      500,
    );
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    },
  },
  components: {},
};
</script>

<style scoped>
.auth-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 600px;
  margin: 0 auto 69px;
}

.notice-info {
  margin-left: 0;
}
</style>
